import { RootState } from "../../store";
import { SavingsOpportunitiesSliceInitialState } from "../savingsOpportunitiesSlice";

export const savingsOpportunitiesStateSelector = (
  state: RootState,
): SavingsOpportunitiesSliceInitialState => {
  return state.savingsOpportunities;
};
